export default {
  clean: () => import("/runner/_work/nova-widget/nova-widget/domains/layout/layouts/clean.vue").then(m => m.default || m),
  default: () => import("/runner/_work/nova-widget/nova-widget/domains/layout/layouts/default.vue").then(m => m.default || m),
  error: () => import("/runner/_work/nova-widget/nova-widget/domains/layout/layouts/error.vue").then(m => m.default || m)
}